export default Object.freeze({
  DEFAULT_MAX_LENGTH: 255,
  USER_NAME_MAX_LENGTH: 150,
  TELEPHONE_MAX_LENGTH: 15,
  EMAIL_MAX_LENGTH: 150,
  NODE_NAME_MAX_LENGTH: 150,
  PASSWORD_MAX_LENGTH: 150,
  NODE_CONFIG_MAX_LENGTH: 2048,
});
